import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateUtilsService {

  formatearFecha(date: string | Date | null): string {
    if (!date) return '';

    let fecha: Date;
    
    if (typeof date === 'string' || typeof date === 'number') {
      fecha = new Date(date);
    } else {
      fecha = date;
    }

    return fecha.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}
